<template>
  <div>
    <FormMultiSelect :value="value" @input="valueUpdated" :field="field" :options="userList" :loading="userListLoading" placeholder="Select Users" v-if="!errorLabel && editable" />
    <span v-if="!editable">
      <span class="label label-success mr-1" v-for="userId in value" :key="userId">
        {{getLookupName(userList, userId)}}
      </span>
    </span>
    <span class="text-danger" v-if="errorLabel">{{errorLabel}}</span>
  </div>
</template>

<script>
import form from '@/mixins/form'

export default {
  name: "AutomationUserListField",
  mixins: [form],
  props: {
    field: String,
    value: Array,
    editable: Boolean
  },
  data() {
    return {
      userList: [],
      users: [],
      userListLoading: false,
      errorLabel: null
    }
  },
  mounted() {
    // Get User list
    // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
    this.userListLoading = true
    this.errorLabel = null

    this.$apiService.userService.getUserList()
    .then(list => {
      this.userList = list.data.map(userInfo => {
        return {
          value: userInfo.id,
          name: userInfo.name
        }
      })
      this.userListLoading = false
    })
    .catch(err => {
      this.userListLoading = false
      if(err.response.status == 403)
        this.errorLabel = 'Permission denied to user list'
      else
        this.errorLabel = 'Error accessing user list'
    })
  },
  computed: {
  },
  methods: {
    valueUpdated(evt) {
      this.$emit('input', evt)

      // Also update lookup info too
      var lookupData = {}
      if(evt) {
        evt.forEach(listValue => {
          lookupData[parseInt(listValue)] = this.getLookupName(this.userList, listValue)
        })
      }

      this.$emit('updateInfo', lookupData)
    }
    
  }
}
</script>